const App = {
  SetBackground: () => {
    $("[setBackground]").each(function () {
      var background = $(this).attr("setBackground");
      $(this).css({
        "background-image": "url(" + background + ")",
        "background-size": "cover",
        "background-position": "center center",
      });
    });
    $("[setBackgroundRepeat]").each(function () {
      var background = $(this).attr("setBackgroundRepeat");
      $(this).css({
        "background-image": "url(" + background + ")",
        "background-repeat": "repeat",
      });
    });
  },
  EqualHeightElement: (el) => {
    let height = 0;
    let thisHeight = 0;
    $(el).each(function () {
      thisHeight = $(this).height();
      if (thisHeight > height) {
        height = thisHeight;
      }
    });
    $(el).height(height);
  },
  ScrollTo: (y) => {
    $("html, body").animate(
      {
        scrollTop: y,
      },
      1000
    );
  },
  Init: () => {
    App.ScrollTo();
    App.SetBackground();
  },
};

function InitSlider() {
  var latestNews = new Swiper(".latest-news .swiper-container", {
    slidesPerView: 1,
    spaceBetween: 20,
    autoplay: {
      delay: 3000,
    },
    navigation: {
      clickable: !0,
      nextEl: ".latest-news .swiper-next",
      prevEl: ".latest-news .swiper-prev",
    },
  });
  var eventsSlide = new Swiper(".home-our-events .swiper-container", {
    slidesPerView: 3,
    spaceBetween: 30,
    autoplay: {
      delay: 7000,
    },
    observer: true,
    observeParents: true,
    navigation: {
      clickable: !0,
      nextEl: ".home-our-events .swiper-next",
      prevEl: ".home-our-events .swiper-prev",
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      575: {
        slidesPerView: 1,
      },
    },
    pagination: {
      el: ".home-our-events .swiper-pagination",
      clickable: !0,
      type: "bullets",
    },
  });
  $(".our-clients-slider .swiper-container").each(function (index, element) {
    var $this = $(this);
    $this.addClass("tri-instance-" + index);
    $this
      .parent()
      .find(".swiper-prev")
      .addClass("btn-prev-" + index);
    $this
      .parent()
      .find(".swiper-next")
      .addClass("btn-next-" + index);
    $this
      .parent()
      .find(".swiper-pagination")
      .addClass("swiper-pagination-" + index);
    var swiper = new Swiper(".tri-instance-" + index, {
      lazy: true,
      speed: 1205,
      spaceBetween: 10,
      slidesPerColumn: 2,
      slidesPerView: 7,
      slidesPerGroup: 7,
      observer: true,
      observeParents: true,
      breakpoints: {
        992: {
          slidesPerView: 5,
          slidesPerGroup: 5,
        },
        768: {
          slidesPerView: 4,
          slidesPerGroup: 4,
        },

        576: {
          slidesPerView: 3,
          slidesPerGroup: 3,
        },
      },
      navigation: {
        nextEl: ".btn-next-" + index,
        prevEl: ".btn-prev-" + index,
      },
      pagination: {
        el: ".swiper-pagination-" + index,
        clickable: !0,
        type: "bullets",
      },
    });
  });

  if ($(".testimonials-slider").length) {
    var sliderThumbs = new Swiper(".thumbs", {
      slidesPerView: 5,
      spaceBetween: 15,
      observer: true,
      loop: true,
      grabCursor: true,
      observeParents: true,
      centeredSlides: true,
      breakpoints: {
        768: {
          slidesPerView: 3,
        },
      },
    });
    var sliderImages = new Swiper(".gallery", {
      slidesPerView: 1,
      spaceBetween: 20,
      observer: true,
      centeredSlides: true,
      loop: true,
      observeParents: true,
      pagination: {
        el: ".testimonials-slider .swiper-pagination",
        clickable: !0,
        type: "bullets",
      },
      thumbs: {
        swiper: sliderThumbs,
      },
    });
  }
  if ($(".our-partners").length) {
    var sliderThumbs = new Swiper(".our-partners-thumbs", {
      slidesPerView: 4,
      spaceBetween: 20,
      observer: true,
      grabCursor: true,
      observeParents: true,
      breakpoints: {
        768: {
          slidesPerView: 3,
        },
      },
    });
    var sliderImages = new Swiper(".our-partners-gallery", {
      slidesPerView: 1,
      spaceBetween: 20,
      observer: true,
      observeParents: true,
      pagination: {
        el: ".our-partners .swiper-pagination",
        clickable: !0,
        type: "bullets",
      },
      thumbs: {
        swiper: sliderThumbs,
      },
    });
  }

  if ($(".our-reward-slider").length) {
    var sliderThumbs2 = new Swiper(".our-reward-thumbs", {
      slidesPerView: 1,
      spaceBetween: 30,
      observer: true,
      observeParents: true,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
    });
    var sliderImages2 = new Swiper(".our-reward-gallery", {
      slidesPerView: 1,
      spaceBetween: 20,
      observer: true,
      observeParents: true,
      pagination: {
        el: ".our-reward-slider .swiper-pagination",
        clickable: !0,
        type: "bullets",
      },
      thumbs: {
        swiper: sliderThumbs2,
      },
    });
  }
}

function Headers() {
  $(document).on("click", ".toggle-btn", function () {
    $(this).toggleClass("active");
    $(".mobile-nav-inner").toggleClass("active");
    $(".header .overlay").toggleClass("active");
  });
  $(document).on("click", ".close-btn", function () {
    $(this).toggleClass("active");
    $(".mobile-nav-inner").removeClass("active");
    $(".header .overlay").removeClass("active");
  });
  $(document).on("click", ".header .overlay", function () {
    $(this).removeClass("active");
    $(".mobile-nav-inner").removeClass("active");
    $(".toggle-btn").removeClass("active");
  });
  $(document).on(
    "click",
    ".mobile-nav-inner li.has-dropdown > .icon-dropdown",
    function () {
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(this).parents(".has-dropdown").removeClass("active");
        $(this).next().slideUp();
      } else {
        $(".header .nav-sub").slideUp();
        $(".icon-dropdown").removeClass("active");
        $(".has-dropdown").removeClass("active");
        $(this).toggleClass("active").next().slideDown();
        $(this).parents(".has-dropdown").toggleClass("active");
      }
    }
  );
  $(document).on(
    "click",
    ".mobile-nav-inner li.has-child > .icon-dropdown-2",
    function () {
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(this).parents(".has-child").removeClass("active");
        $(this).next().slideUp();
      } else {
        $(".header .menu-child").slideUp();
        $(".icon-dropdown-2").removeClass("active");
        $(".has-dropdown-2").removeClass("active");
        $(this).toggleClass("active").next().slideDown();
        $(this).parents(".has-child").toggleClass("active");
      }
    }
  );
  $(document).on("click", ".sidebar-mb-filter", function () {
    $(this).toggleClass("active");
    $(".sidebar-inner").slideToggle();
  });
  if ($(".hero-banner,.banner-subpage").length) {
    $(".header").removeClass("header-2");
  } else {
    $(".header").addClass("header-2");
  }
}
//mapping
function mappings() {
  if ($(".header").length) {
    var moveNav = new MappingListener({
      selector: ".header .menu",
      mobileWrapper: ".mobile-nav-inner",
      mobileMethod: "appendTo",
      desktopWrapper: ".header .logo",
      desktopMethod: "insertAfter",
      breakpoint: 1200,
    }).watch();
    var movebutton = new MappingListener({
      selector: ".header .account-btn",
      mobileWrapper: ".mobile-nav-inner",
      mobileMethod: "appendTo",
      desktopWrapper: ".header .cart",
      desktopMethod: "insertBefore",
      breakpoint: 1200,
    }).watch();
    var movebutton2 = new MappingListener({
      selector: ".header .contact-btn",
      mobileWrapper: ".mobile-nav-inner",
      mobileMethod: "appendTo",
      desktopWrapper: ".header .account-btn",
      desktopMethod: "insertBefore",
      breakpoint: 1200,
    }).watch();
  }
}
function accordion() {
  if ($(".accordions").length) {
    $(".accordion-item.active").find(".accordion-content").show();
    $(".accordion-heading").on("click", function () {
      if (!$(this).parent().is(".active")) {
        $(this)
          .parent()
          .toggleClass("active")
          .children(".accordion-content")
          .slideToggle(500)
          .parent()
          .siblings(".active")
          .removeClass("active")
          .children(".accordion-content")
          .slideToggle(500);
      } else {
        $(this).parent().toggleClass("active");
        $(this).next().slideToggle(500);
      }
    });
  }
}

function jarallax() {
  $(".jarallax").jarallax({
    speed: 0.2,
    disableParallax: / iPad | iPhone | iPod | Android /,
    disableVideo: / iPad | iPhone | iPod | Android /,
  });
}

function myTabs() {
  $(".my-tabs").each(function () {
    var $this = $(this);
    $this.find(".tabs-nav li:first").addClass("active");
    $this.find(".tab-content:first").show();
    $this.find(".tabs-nav li").click(function () {
      var corresponding = $(this).data("tab");
      $this.find(".tab-content").hide();
      $this.find(".tab-content." + corresponding).show();
      $this.find(".tabs-nav li").removeClass("active");
      $(this).addClass("active");
      $(".slick-container").slick("setPosition", 0);
    });
  });
}
function selectUi() {
  $(".dropdown").on("click", ".dropdown-select", function () {
    if ($(this).parents(".dropdown").hasClass("open")) {
      $(this).parents(".dropdown").removeClass("open");
      $(this).siblings(".dropdown-list").hide();
    } else {
      $(".dropdown").removeClass("open");
      $(this).parents(".dropdown").addClass("open");
      $(".dropdown-list").hide();
      $(this).siblings(".dropdown-list").show();
    }
  });
  var allOptions = $(".dropdown-list").children(".dropdown-item");
  $(".dropdown-list").on("click", ".dropdown-item", function () {
    allOptions.removeClass("selected");
    $(this).addClass("selected");
    $(this)
      .parents(".dropdown")
      .find(".dropdown-selected")
      .css("color", "#212429")
      .html($(this).html());

    $(this).parents(".dropdown-list").toggle();
    $(this).parents(".dropdown").toggleClass("open");
    $("input#inputInit").val($(this).data("val"));
  });
  var $menu = $(".dropdown");

  $(document).mouseup(function (e) {
    if (!$menu.is(e.target) && $menu.has(e.target).length === 0) {
      $menu.removeClass("open");
      $menu.find(".dropdown-list").hide();
    }
  });
}

function checkWidth() {
  var $window = $(window);
  var windowsize = $window.width();
  if (windowsize >= 768) {
    $(".sidebar-inner").removeAttr("style");
  }
  if (windowsize >= 1025) {
    $(".header").find(".nav-sub").removeAttr("style");
    $(".scroll-header").find(".menu-list").removeAttr("style");
  }
  if (windowsize >= 1200) {
    $(".header .overlay").removeClass("active");
    $(
      ".header .mobile-nav-inner,.has-dropdown,.icon-dropdown,.icon-dropdown-2,.has-child"
    ).removeClass("active");
  }
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
}
function replaceSvg() {
  $("img.svg").each(function () {
    var $img = $(this);
    var imgID = $img.attr("id");
    var imgClass = $img.attr("class");
    var imgURL = $img.attr("src");
    $.get(
      imgURL,
      function (data) {
        // Get the SVG tag, ignore the rest
        var $svg = $(data).find("svg");

        // Add replaced image's ID to the new SVG
        if (typeof imgID !== "undefined") {
          $svg = $svg.attr("id", imgID);
        }
        // Add replaced image's classes to the new SVG
        if (typeof imgClass !== "undefined") {
          $svg = $svg.attr("class", imgClass + " replaced-svg");
        }

        // Remove any invalid XML tags as per http://validator.w3.org
        $svg = $svg.removeAttr("xmlns:a");

        // Replace image with new SVG
        $img.replaceWith($svg);
      },
      "xml"
    );
  });
}
function adjustProductAmount() {
  $(".plus").on("click", function () {
    $(this)
      .parents(".amount,.amount-2")
      .find(".input")
      .val(+$(this).parents(".amount,.amount-2").find(".input").val() + 1);
    $(".woocommerce-cart-form .update-cart.btn").removeAttr("disabled");
  });
  $(".minus").click(function () {
    if ($(this).parents(".amount,.amount-2").find(".input").val() > 1) {
      if ($(this).parents(".amount,.amount-2").find(".input").val() > 1)
        $(this)
          .parents(".amount,.amount-2")
          .find(".input")
          .val(+$(this).parents(".amount,.amount-2").find(".input").val() - 1);
    }
  });
}
function fixedNav() {
  var nav = $(".header");
  if (nav.length) {
    var offsetTop = nav.offset().top,
      TH = $(".header").height(),
      headerHeight = nav.height(),
      injectSpace = $("<div />", {
        height: headerHeight,
      }).insertAfter(".header");
    injectSpace.hide();
    $(window).on("load scroll resize", function () {
      if ($(window).scrollTop() > offsetTop) {
        nav.addClass("fixed-hide");
        injectSpace.show();
      } else {
        nav.removeClass("fixed-hide");
        injectSpace.hide();
      }

      if ($(window).scrollTop() > 130) {
        nav.addClass("fixed-show");
      } else {
        nav.removeClass("fixed-show");
      }
    });
  }
}

function scrollToTop() {
  $(window).scroll(function () {
    if ($(this).scrollTop() > 200) {
      $("#back-to-top").addClass("show");
    } else {
      $("#back-to-top").removeClass("show");
    }
  });
  $("#back-to-top").on("click", function () {
    $("html, body").animate({ scrollTop: 0 }, 1000, "easeInOutExpo");
    return false;
  });
}
function checkboxForm() {
  $(".shipping-info .custom-checkbox input").click(function () {
    if ($(this).is(":checked")) {
      $(this).parents(".shipping-info").find(".another-address").hide();
    } else {
      $(this).parents(".shipping-info").find(".another-address").show();
    }
  });
}
function countUp() {
  if ($(".statistics").length) {
    var options = {
      useEasing: true,
      useGrouping: true,
      separator: ",",
      decimal: ".",
      prefix: "",
      suffix: "",
    };
    var counts = [];
    $(".counter-1").each(function () {
      var num = $(this).attr("data-count"); //end count
      var nuen = $(this).text();
      if (nuen === "") {
        nuen = 0;
      }

      counts.push(new CountUp(this, nuen, num, 0, 3, options));
    });
    if ($(".statistics-1").length) {
      var waypoint1 = new Waypoint({
        element: document.getElementsByClassName("statistics-1"),
        handler: function (direction) {
          if (direction == "up") {
            for (var i = 0; i < counts.length; i++) {
              counts[i].reset();
            }
          } else {
            for (var i = 0; i < counts.length; i++) {
              counts[i].start();
            }
          }
        },
        offset: "80%",
      });
    }
  }
}
$(window).resize(checkWidth).trigger("resize");
$(document).ready(function () {
  App.Init();
  InitSlider();
  replaceSvg();
  Headers();
  mappings();
  selectUi();
  checkboxForm();
  scrollToTop();
  fixedNav();
  countUp();
  adjustProductAmount();
  accordion();
  jarallax();
  myTabs();
  checkWidth();
  $("[data-fancybox]").fancybox({
    closeExisting: true,
    loop: true,
    touch: false,
    afterLoad: function () {
      $(".slider-1").slick("setPosition", 0);
    },
  });
  $('[data-fancybox="images"]').fancybox({
    baseClass: "myFancyBox",
    thumbs: {
      autoStart: true,
      axis: "x",
    },
  });
});
